import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["imgUrl", "imgGradient", "imgPosition", "view", "title", "titleProps", "text", "textProps", "date", "dateProps", "compact", "button", "buttonProps", "classes", "onButtonClick", "grey"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { useMediaQuery } from "../hooks";
import { Clamp } from "../internal/Clamp";
import { TextBase } from "../internal/TextBase";
import { Button } from '../Button';
import Title from '../Title';
import { imgPositions, views } from './constants';
import styles from './Card.css';
var cx = classNames.bind(styles);

var getLevelTitle = function getLevelTitle(isImgPositionFull, isDesktop, isMobile) {
  if (isImgPositionFull) {
    return isDesktop ? 2 : 3;
  }

  return isMobile ? 3 : 4;
};

var Card = /*#__PURE__*/forwardRef(function Card(_ref, ref) {
  var imgUrl = _ref.imgUrl,
      imgGradient = _ref.imgGradient,
      _ref$imgPosition = _ref.imgPosition,
      imgPosition = _ref$imgPosition === void 0 ? imgPositions.top : _ref$imgPosition,
      _ref$view = _ref.view,
      view = _ref$view === void 0 ? views.news : _ref$view,
      title = _ref.title,
      titleProps = _ref.titleProps,
      text = _ref.text,
      textProps = _ref.textProps,
      date = _ref.date,
      dateProps = _ref.dateProps,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      button = _ref.button,
      buttonProps = _ref.buttonProps,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      onButtonClick = _ref.onButtonClick,
      _ref$grey = _ref.grey,
      grey = _ref$grey === void 0 ? false : _ref$grey,
      rest = _objectWithoutProperties(_ref, _excluded);

  var isNews = view === views.news;
  var isOffers = view === views.offers;
  var isImgPositionFull = imgPosition === imgPositions.full;
  var breakpoints = useMediaQuery('xs', 'lg');
  var isMobile = breakpoints.xs;
  var isDesktop = breakpoints.lg;
  var dateComponent = date && /*#__PURE__*/React.createElement(TextBase, _extends({
    size: view === views.news ? 's' : 'm',
    color: "N100",
    classes: {
      root: cx('date')
    }
  }, dateProps), date);
  return /*#__PURE__*/React.createElement("article", _extends({
    ref: ref,
    className: cx('root', "view_".concat(view), "position_".concat(imgPosition), {
      has_date: date,
      compact: compact,
      grey: grey
    }, classes.root)
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: cx('image_container', classes.imageContainer)
  }, imgGradient ? /*#__PURE__*/React.createElement("div", {
    className: cx('image', classes.image, _defineProperty({}, "image_".concat(imgGradient), typeof imgGradient === 'string')),
    style: _typeof(imgGradient) === 'object' ? imgGradient : undefined
  }) : /*#__PURE__*/React.createElement("img", {
    className: cx('image', classes.image),
    src: imgUrl,
    alt: "post"
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('body', classes.body)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('content', classes.content)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('title', classes.title)
  }, /*#__PURE__*/React.createElement(Title, _extends({
    level: getLevelTitle(isImgPositionFull, isDesktop, isMobile)
  }, titleProps), title)), isOffers && dateComponent, /*#__PURE__*/React.createElement(TextBase, _extends({
    size: "m",
    classes: {
      root: cx('text')
    }
  }, textProps), /*#__PURE__*/React.createElement(Clamp, null, text))), isNews && dateComponent, isOffers && /*#__PURE__*/React.createElement("div", {
    className: cx('actions', classes.actions)
  }, /*#__PURE__*/React.createElement(Button, _extends({
    theme: isImgPositionFull ? 'b2c' : 'secondary',
    onClick: onButtonClick
  }, buttonProps), button))));
});
export default Card;